import React from 'react'

const Header = () => {
  return (
    <div className='header' >
    Welcome to the ERC Calculator: <a href='https://youtu.be/NL-f3QcM1tY' >--How to video--</a>

  <br/>

    Some more features are being added as well you can check the Beta Website here : <br/> <a href='https://nortontheveninv2.netlify.app/calculators'>--Version 2 Beta Website--</a></div>
  )
}

export default Header 
